export const CALL_REQUEST_COUNTRIES = ["DK", "NO", "SE"] as const;

export type CallRequestCountry = (typeof CALL_REQUEST_COUNTRIES)[number];

/**
 * The values docs/website-embed.md documents: a country code, or the site's language tag.
 * Matched case-insensitively; anything else is rejected, so a typo cannot store a wrong country.
 */
const COUNTRY_ALIASES: Record<string, CallRequestCountry> = {
  dk: "DK",
  "da-dk": "DK",
  no: "NO",
  "no-no": "NO",
  "nb-no": "NO",
  se: "SE",
  "sv-se": "SE",
};

export type ParsedCallRequestCountry =
  | { ok: true; country: CallRequestCountry | null }
  | { ok: false };

/**
 * Optional website country. Missing, null or blank means "not sent".
 * Stored as DK, NO, or SE.
 */
export function parseCallRequestCountry(value: unknown): ParsedCallRequestCountry {
  if (value == null) {
    return { ok: true, country: null };
  }
  if (typeof value !== "string") {
    return { ok: false };
  }
  const key = value.trim().toLowerCase();
  if (!key) {
    return { ok: true, country: null };
  }
  const country = COUNTRY_ALIASES[key];
  if (!country) {
    return { ok: false };
  }
  return { ok: true, country };
}

export function callRequestCountryLabel(
  country: string | null | undefined,
  t: (key: string) => string,
): string {
  if (country === "DK") return t("calls.countryDK");
  if (country === "NO") return t("calls.countryNO");
  if (country === "SE") return t("calls.countrySE");
  return "";
}
